import React, { memo } from 'react';
import classNames from 'classnames';
import cls from '../ConstructionProgressDnD.module.css';

interface EmptyConstructionProgressProps {
    classes?: string;
    is_customer: boolean;
    is_owner: boolean;
    progress_tariff_access_edit: boolean;
}

export const EmptyConstructionProgress = memo(
    ({
        classes,
        is_customer,
        is_owner,
        progress_tariff_access_edit,
    }: EmptyConstructionProgressProps) => {
        return (
            <>
                {is_customer || (!is_owner && !progress_tariff_access_edit) ? (
                    <>
                        {is_customer ? (
                            <div className={cls.emptyCustomer}>
                                {i18next.t('EmptyConstructionProgress.return.emptyCustomer')}
                            </div>
                        ) : (
                            <div className={cls.emptyCustomer}>
                                {i18next.t('EmptyConstructionProgress.return.emptyEmployee')}
                            </div>
                        )}
                    </>
                ) : (
                    <div className={classNames(cls.ConstructionProgressDnD, [classes])}>
                        <svg
                            className={cls.miniZone}
                            width="28"
                            height="28"
                            viewBox="0 0 26 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                className={cls.pathSpecific}
                                d="M12.9999 16.8706C15.3576 16.8706 17.2688 14.9594 17.2688 12.6017C17.2688 10.244 15.3576 8.33276 12.9999 8.33276C10.6422 8.33276 8.73096 10.244 8.73096 12.6017C8.73096 14.9594 10.6422 16.8706 12.9999 16.8706Z"
                                fill="#C1C4C9"
                            />
                            <path
                                className={cls.pathSpecific}
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0.75 7.71191C0.75 5.77892 2.317 4.21191 4.25 4.21191H21.75C23.6831 4.21191 25.25 5.77892 25.25 7.71191V17.4908C25.25 19.4236 23.6831 20.9908 21.75 20.9908H4.25C2.317 20.9908 0.75 19.4236 0.75 17.4908V7.71191ZM18.5681 12.6014C18.5681 15.6765 16.0752 18.1696 13 18.1696C9.92479 18.1696 7.43183 15.6765 7.43183 12.6014C7.43183 9.52614 9.92479 7.03318 13 7.03318C16.0752 7.03318 18.5681 9.52614 18.5681 12.6014ZM3.03284 7.10759C2.69457 7.10759 2.42034 7.38181 2.42034 7.72009C2.42034 8.05836 2.69457 8.33259 3.03284 8.33259H5.51996C5.85823 8.33259 6.13246 8.05836 6.13246 7.72009C6.13246 7.38181 5.85823 7.10759 5.51996 7.10759H3.03284Z"
                                fill="#C1C4C9"
                            />
                            <path
                                className={cls.pathSpecific}
                                d="M7.32031 3.02423C7.32031 1.63015 8.45045 0.5 9.84455 0.5H16.1552C17.5493 0.5 18.6795 1.63015 18.6795 3.02423H7.32031Z"
                                fill="#C1C4C9"
                            />
                        </svg>
                        <span>
                            {i18next.t(
                                'EmptyConstructionProgress.return.constructionProgressDnD.span.part1'
                            )}
                            <br />
                            {i18next.t(
                                'EmptyConstructionProgress.return.constructionProgressDnD.span.part2'
                            )}
                        </span>
                    </div>
                )}
            </>
        );
    }
);
